import { FC, ReactNode } from 'react';
import { Button, Card, Heading, Paragraph } from '@expressable/syntax-ds';

type Props = {
  heading: string;
  copy: string;
  cta: string;
  icon: ReactNode;
  onBailout: () => void;
  cardTestId?: string;
};

const Component: FC<Props> = ({ heading, copy, cta, icon, onBailout, cardTestId }) => {
  return (
    <Card className="flex-1 p-e40 mobile-d:p-e32" data-testid={cardTestId}>
      <Heading level="h6" className="flex items-center -ml-8">
        <div className="p-e12 rounded-full bg-orchid-50 text-purple-500 mx-8">{icon}</div>
        {heading}
      </Heading>
      <div className="flex justify-start gap-40 md:gap-e56 flex-wrap">
        <Paragraph size="md">{copy}</Paragraph>
      </div>
      <Button size="md" variant="secondary" className="mt-32" onClick={onBailout}>
        {cta}
      </Button>
    </Card>
  );
};

export const SignupConsultationBailout = Component;
